import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=4d47aa3e&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47aa3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d47aa3e')) {
      api.createRecord('4d47aa3e', component.options)
    } else {
      api.reload('4d47aa3e', component.options)
    }
    module.hot.accept("./orderList.vue?vue&type=template&id=4d47aa3e&scoped=true&", function () {
      api.rerender('4d47aa3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderList.vue"
export default component.exports